export default function focusElement(selector) {
    return document.querySelector(selector)?.focus();
}
